module.exports = __webpack_public_path__ + "img/czzn_042.3299ab03.png";